import service from './request'
import uploadService from "./uploadRequest.js";

/**
 * 获取短信任务列表信息
 */
 export const getList = data => {
  return service({
      showLoading: true,//调用预加载
      url: '/platform/sms/task/getList',
      method: 'post',
      type: 'body',
      data
  })
}


/**
 * 添加短信任务信息
 */
 export const addInfo = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/sms/task/addInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 修改短信任务信息
 */
 export const updateInfo = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/sms/task/updateInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 删除短信任务信息
 */
 export const delInfo = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/sms/task/delInfo',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 解析号码excel文件
 */
 export const impExcel = data => {
  return uploadService({
      showLoading: true,
      url: '/platform/sms/task/resolverMobileExcel',
      method: 'post',
      data
  })
}

/**
 * 获取发送明细列表
 */
 export const getSendMobileList = data => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/sms/task/getSendMobileList',
      method: 'post',
      type: 'body',
      data
  })
}

/**
 * 发送业务模板参数明细
 */
 export const getSmsTaskBusiModelParam = params => {
  return service({
      showLoading: false,//调用预加载
      url: '/platform/sms/task/getSmsTaskBusiModelParam',
      method: 'post',
      params
  })
}





// WEBPACK FOOTER //
// ./src/http/SmsTaskManagement.js